export default "__VITE_ASSET__Bdr4ucp7__"